import { Component, OnInit } from "@angular/core";
import { CloudService } from "../cloud.service";
import { AngularFireUploadTask } from "@angular/fire/storage";

@Component({
  selector: "app-upload-file",
  templateUrl: "./upload-file.component.html",
  styleUrls: ["./upload-file.component.css"]
})
export class UploadFileComponent implements OnInit {
  files: any = [];
  //   uploadTask: AngularFireUploadTask | undefined;

  constructor(public cs: CloudService) {}

  ngOnInit() {}

  uploadFile(event) {
    for (let index = 0; index < event.length; index++) {
      const element = event[index];
      this.files.push(element.name);
      this.cs.upload(element);
    }
  }

  deleteAttachment(index) {
    this.files.splice(index, 1);
  }

  public analyze() {
    this.cs.callExtractText(this.cs.imagePath);
  }
}
